module.exports = {"Poll":"نظر سنجی"}